import { FC } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormErrorIcon,
  FormErrorMessage,
  FormLabel,
  Heading,
  Input,
  Stack,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { StepRuler } from './StepRuler';
import { ChevronRight, DollarCircled } from '../../../../assets';
import { useMobileCheckDepositContext } from '../../context';

export const DonationAmount: FC = () => {
  const {
    data: {
      steps: { activeStep, prevSteps },
    },
    commands: { handleNextStep, handleFormData, handleStep },
  } = useMobileCheckDepositContext();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const step = 1;
  const isActive = activeStep === 1;

  const hasStep = prevSteps.includes(step);
  const handleDonorAmt = () => {
    if (hasStep) {
      handleStep(step);
    }
  };

  const onSubmit = (data: any) => {
    handleFormData(data);
    handleNextStep();
  };

  return isActive ? (
    <Stack direction="row">
      <StepRuler icon={DollarCircled} />
      <Stack spacing={4} w="full">
        <Heading fontSize="xl" color="brand.secondary.swatch4">
          Donation Amount
        </Heading>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={4}>
            <FormControl isInvalid={!!errors?.giftAmount}>
              <FormLabel htmlFor="giftAmount" color="brand.monochromatic.700">
                Donation Amount (in USD)
              </FormLabel>
              <Input
                step=".01"
                id="giftAmount"
                type="number"
                {...register('giftAmount', {
                  required: 'Amount must be a value',
                  min: {
                    value: 1,
                    message: 'Amount must be more than $0',
                  },
                  max: {
                    value: 9999999,
                    message: 'Amount must be less than $9999999',
                  },
                })}
              />
              <FormErrorMessage>
                <>
                  <FormErrorIcon />
                  {errors?.giftAmount?.message}
                </>
              </FormErrorMessage>
            </FormControl>
            <Box alignSelf="flex-end">
              <Button
                colorScheme="blue"
                type="submit"
                rightIcon={<ChevronRight boxSize={3} />}
              >
                Next
              </Button>
            </Box>
          </Stack>
        </form>
      </Stack>
    </Stack>
  ) : (
    <Button
      p={0}
      colorScheme="blue"
      variant="ghost"
      onClick={handleDonorAmt}
      leftIcon={<DollarCircled boxSize={6} />}
      textDecoration={hasStep ? 'underline' : 'none'}
    >
      Donation Amount
    </Button>
  );
};
